import React, { useEffect, useState } from "react";

import Card from "@busbud/design-system-components/dist/Card";

import type { ExpandableCardContentProps } from "./expandable-card-content";

import { ExpandableCardContent } from "./expandable-card-content";

export interface ExpandableCardProps
  extends Omit<ExpandableCardContentProps, "is_expanded"> {
  className?: string;
  card_classes_override?: React.ComponentProps<typeof Card>["classes"];
  children: React.ReactNode;
  footer?: React.ReactNode;
  header: React.ReactNode;
  is_default_expanded?: boolean;
  show_divider?: boolean;
}

/* eslint-disable-next-line jsdoc/require-param */
/**
 * @deprecated Use the new `CollapsibleCard`:
 *
 * ```tsx
 * import { CollapsibleCard } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://horizon-web-ui-docs.busbud-int.com/?path=/docs/data-display-collapsiblecard)
 */
export const ExpandableCard: React.FC<ExpandableCardProps> = ({
  card_collapse_classes_override = {},
  card_classes_override,
  card_header_classes_override = {},
  children,
  className,
  is_default_expanded = true,
  header,
  footer,
  onCollapse,
  onExpand,
  onClick,
  show_divider,
  ...otherProps
}) => {
  const [expanded, setExpanded] = useState(is_default_expanded);

  useEffect(() => {
    setExpanded(is_default_expanded);
  }, [is_default_expanded]);

  const handleOnClick = () => {
    setExpanded(!expanded);
    if (onClick) {
      onClick();
    }
  };

  return (
    <Card className={className} classes={card_classes_override} {...otherProps}>
      <ExpandableCardContent
        card_collapse_classes_override={card_collapse_classes_override}
        card_header_classes_override={card_header_classes_override}
        header={header}
        onCollapse={onCollapse}
        onExpand={onExpand}
        is_expanded={expanded}
        onClick={handleOnClick}
        show_divider={show_divider}
      >
        {children}
      </ExpandableCardContent>
      {footer}
    </Card>
  );
};
